var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("ESG Project Tab")]),_c('div',{staticClass:"h4 py-5"},[_vm._v("呈現於ESG Page分頁Tab標題")]),_vm._l((_vm.csr.tabs),function(item,i){return _c('div',{key:i,staticClass:"form-item pa-5 h4"},[_vm._v(_vm._s(item.title))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }